import { isElementInViewport } from './helpers';

export default class ScrollAnimations {
  constructor(selector, animation) {
    this.selector = selector;
    this[animation]();

    this.changeHeaderBackground();
  }

  showElements() {
    let elementsToShow = document.querySelectorAll(this.selector);
    this.changeClassInViewport(elementsToShow);
  }

  topAnimation(){
    let element = document.querySelector(this.selector);
    window.addEventListener('scroll', function (evt) {
      if(window.pageYOffset > 50) {
        element.classList.add("-scrolled");
      } else {
        element.classList.remove("-scrolled");
      }
    });
  }

  fixedElement() {
    let fixedElement = document.querySelector(this.selector);

    window.addEventListener('scroll', function (evt) {
      let currentScroll = window.pageYOffset;
      let elementOffsetTop = fixedElement.offsetTop;
      let header = document.querySelector('.site-header');

      if (currentScroll > elementOffsetTop) {
        let headerHeight = window.getComputedStyle(header).getPropertyValue('height');
        fixedElement.classList.add('-sticky');
        fixedElement.style.top = headerHeight;
      } else {
        fixedElement.classList.remove('-sticky');
      }

    });
  }

  changeClassInViewport(elements, visibleClass = 'is-visible') {
    let scroll = window.requestAnimationFrame || function (callback) {
      window.setTimeout(callback, 1000 / 60)
    };
    if (elements.length === 0 && !NodeList.prototype.isPrototypeOf(elements)) {
      return;
    }
    elements.forEach(function (element) {
      if (isElementInViewport(element) && element.classList) {
        element.classList.add(visibleClass);
      }
      // else if(element.classList) {
      //     element.classList.remove(visibleClass);
      // } else {
      //     element.setAttribute('class', visibleClass);
      // }
    });


    scroll(() => {
      this.changeClassInViewport(elements);
    });
  }

  changeHeaderBackground() {
    let header = document.querySelector('.site-header');

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 0) {
        header.classList.add('-white-background');
      } else {
        header.classList.remove('-white-background');
      }
    });
  }
}